import { SimpleClusterForm } from "@/types";
import { useFormikContext } from "formik";
import { TextField } from "@/components/forms/fields";
import { Separator } from "@/components/ui/separator";
import { NetworkServices } from "../../CreateVirtualMachineForm/steps/NetworkServices";

const AddNetworkServices: React.FC<{ onNameChange: () => void }> = ({ onNameChange }) => {
  const { values } = useFormikContext<SimpleClusterForm>();

  return (
    <div className="flex flex-1 flex-col gap-6 lg:max-w-[760px]">
      {/* VM Name card */}
      <div className="overflow-hidden rounded-[12px] border border-border bg-background">
        <div className="flex flex-col gap-[6px] p-[18px]">
          <div className="flex items-center gap-1 text-[14px] leading-[20px] text-foreground">
            Virtual Machine Name
          </div>
          <TextField
            name="name"
            value={values.name}
            placeholder="Enter your Virtual Machine name"
            baseHOCClassName="pb-0"
            className="h-[36px] border border-border bg-background text-foreground placeholder:text-muted-foreground focus:ring-0 focus-visible:ring-0 focus-visible:ring-offset-0"
            onFocus={() => onNameChange()}
          />
        </div>
      </div>

      {values.supplier === "internal" ? (
        <>
          <Separator className="bg-border" />
          <NetworkServices />
        </>
      ) : null}
    </div>
  );
};

export default AddNetworkServices;
